export default {
  general: {
    appResetTimeoutMinutes: 15,
  },
  filter: {
    enabled: false,
  },
};
